// extracted by mini-css-extract-plugin
export default {"columns":"tableHeader_columns__RcFB3","column":"tableHeader_column__J7mu3","firstColumn":"tableHeader_firstColumn__Cdfqu"};